export const LANDING_PATHS = [
  '/', '/home', '/contato', '/demonstracao', '/termos-de-uso', '/politica-de-privacidade'
];

export function getDomainRedirect(url: URL, appUrl: string, landingUrl: string): URL | null {
  const appOrigin = new URL(appUrl).origin;
  const landingOrigin = new URL(landingUrl).origin;
  if (appOrigin === landingOrigin) return null;

  const path = url.pathname.replace(/\/+$/, '') || '/';
  const isLandingPath = LANDING_PATHS.includes(path);
  if (url.origin === landingOrigin && !isLandingPath) {
    return new URL(`${url.pathname}${url.search}${url.hash}`, appOrigin);
  }
  if (url.origin === appOrigin) {
    if (path === '/') return new URL(`/auth/login${url.search}${url.hash}`, appOrigin);
    if (isLandingPath) return new URL(`${path}${url.search}${url.hash}`, landingOrigin);
  }
  return null;
}
